import React from 'react'
import { normalizeAvatarUrl } from '../services/api'
import './EmployeeComponents.css'

function EmployeeAvatar({ employee, size = 'medium', showStatus = false, status = 'online', showTooltip = false }) {
  // Извлекаем инициалы из ФИО
  const getInitials = (fullName) => {
    if (!fullName) return '??'
    const parts = fullName.trim().split(/\s+/)
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase()
    }
    return fullName.substring(0, 2).toUpperCase()
  }

  // Генерируем цвет на основе имени для консистентности
  const getColor = (name) => {
    if (!name) return '#9E9E9E'
    let hash = 0
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }
    const hue = hash % 360
    return `hsl(${hue}, 65%, 50%)`
  }

  const initials = getInitials(employee?.full_name || employee?.name)
  const backgroundColor = getColor(employee?.full_name || employee?.name)
  const sizeClass = `avatar-${size}`
  const employeeName = employee?.full_name || employee?.name || 'Неизвестно'
  const avatarUrl = normalizeAvatarUrl(employee?.avatar_url || employee?.user?.avatar_url)

  return (
    <div 
      className={`employee-avatar-wrapper ${showTooltip ? 'has-tooltip' : ''}`}
    >
      <div 
        className={`employee-avatar ${sizeClass} ${avatarUrl ? 'avatar-with-image' : ''}`} 
        style={{ backgroundColor }}
        data-tooltip={showTooltip ? employeeName : undefined}
      >
        {avatarUrl ? (
          <img 
            src={avatarUrl} 
            alt={employeeName}
            className="avatar-image"
            onError={(e) => {
              // Если изображение не загрузилось, показываем инициалы
              e.target.style.display = 'none'
              e.target.nextElementSibling.style.display = 'flex'
            }}
          />
        ) : null}
        <span className="avatar-initials" style={{ display: avatarUrl ? 'none' : 'flex' }}>{initials}</span>
        {showStatus && (
          <span className={`avatar-status avatar-status-${status}`}></span>
        )}
      </div>
      {showTooltip && employeeName && (
        <div className="avatar-tooltip">{employeeName}</div>
      )}
    </div>
  )
}

export default EmployeeAvatar

